module.exports = __webpack_public_path__ + "media/images/preview/browser_header_sm-9172c351229ed537008c39bcde86fbd7.png";